import {
  formatMoney,
  formatNumber,
  formatPeriodStart,
  toThousandths,
  type ChartPoint,
  type PeriodUnit,
} from '@platform/design-system';

export type SeriesScale = { readonly unit: PeriodUnit; readonly timeZone: string; readonly locale: string };

type Money = { readonly amount: string; readonly currency: string };

const labelOf = (start: string, scale: SeriesScale): string =>
  formatPeriodStart(start, scale.locale, scale.unit, scale.timeZone);

export const moneyPointOf = (start: string, money: Money, scale: SeriesScale): ChartPoint => ({
  key: start,
  label: labelOf(start, scale),
  value: toThousandths(money.amount),
  display: formatMoney(money, scale.locale),
});

export const countPointOf = (start: string, count: number, scale: SeriesScale): ChartPoint => ({
  key: start,
  label: labelOf(start, scale),
  value: count,
  display: formatNumber(count, scale.locale),
});
